import React from 'react'
import get from 'lodash/get'
import { Component } from 'react'
import { connect } from 'react-redux'
import {
    AccountRecommendationsSettings, AVAILABLE_PURPOSES, ClanRecommendation, getAccountRecommendationsSettings,
    getLeftApplicationCount, getRecommendations,
    RecommendationsPurpose, sendApplication, setAccountRecommendationsSettings
} from '../Actions/ActionRecommendations'
import ViewRecommendations from '../Components/ViewRecommendations/ViewRecommendations'
import { isLoggedIn } from "~/utils/auth"

export type ContainerRecommendations_Props = {
    router: any,

    isFetchingRecommendations: Boolean,
    isFetchingLeftApplicationCount: Boolean,
    isFetchingSendApplication: Boolean,

    isFetchingAccountSettings: Boolean,
    isFetchingClanSettings: Boolean,

    accountSettings: AccountRecommendationsSettings,
    recommendations: Array<ClanRecommendation>,
    leftApplicationCount: number,

    root: String,

    currentAccount: any,

    getAccountRecommendationsSettings: () => void,
    setAccountRecommendationsSettings: (recommendationsSettings: AccountRecommendationsSettings) => void,
    getRecommendations: (purpose: RecommendationsPurpose) => void,
    getLeftApplicationCount: () => void,
    sendApplication: (clan: ClanRecommendation, info: String) => void,
}

export type ContainerRecommendations_State = {
}

const mapStateToProps = (state) => {
    const currentAccountClanId = state.currentAccount.clanId
    const clanData = state.clans.items[currentAccountClanId]

    return {
        isFetchingRecommendations: state.ReducerRecommendations.isFetchingRecommendations,
        isFetchingLeftApplicationCount: state.ReducerRecommendations.isFetchingLeftApplicationCount,
        isFetchingSendApplication: state.ReducerRecommendations.isFetchingSendApplication,

        isFetchingAccountSettings: state.ReducerRecommendations.isFetchingAccountSettings,
        isFetchingClanSettings: state.ReducerRecommendations.isFetchingClanSettings,

        clanData,

        root: state.urls.root,

        accountSettings: state.ReducerRecommendations.accountSettings,
        recommendations: state.ReducerRecommendations.recommendations,
        leftApplicationCount: state.ReducerRecommendations.leftApplicationCount,

        currentAccount: state.currentAccount,
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getAccountRecommendationsSettings: () => {
            dispatch(getAccountRecommendationsSettings())
        },
        setAccountRecommendationsSettings: (recommendationsSettings: AccountRecommendationsSettings) => {
            dispatch(setAccountRecommendationsSettings(recommendationsSettings))
        },
        getRecommendations: (purpose: RecommendationsPurpose) => {
            dispatch(getRecommendations(purpose))
        },
        getLeftApplicationCount: () => {
            dispatch(getLeftApplicationCount())
        },
        sendApplication: (clan: ClanRecommendation, info: String) => {
            dispatch(sendApplication(clan, info))
        },
    }
}

class ContainerRecommendations extends Component<ContainerRecommendations_Props, ContainerRecommendations_State> {

    constructor(props) {
        super(props)

        this.updateAccountSettings = this.updateAccountSettings.bind(this)
        this.getRecommendations = this.getRecommendations.bind(this)
        this.getLeftApplicationCount = this.getLeftApplicationCount.bind(this)
        this.sendApplication = this.sendApplication.bind(this)
    }

    componentDidMount() {
        if (isLoggedIn()) {
            this.props.getAccountRecommendationsSettings()
        }
    }

    updateAccountSettings(recommendationsSettings: AccountRecommendationsSettings) {
        this.props.setAccountRecommendationsSettings(recommendationsSettings)
    }

    getRecommendations(purpose: RecommendationsPurpose) {
        this.props.getRecommendations(purpose)
    }

    getLeftApplicationCount() {
        this.props.getLeftApplicationCount()
    }

    sendApplication(clan: ClanRecommendation, info: String) {
        this.props.sendApplication(clan, info)
    }

    render() {

        const isFetching = this.props.isFetchingRecommendations || this.props.isFetchingLeftApplicationCount || this.props.isFetchingSendApplication

        let purpose = get(this.props.router, 'params.purpose', 'categories')
        let currentSlide = parseInt(get(this.props.router, 'params.currentSlide', 1))
        if (AVAILABLE_PURPOSES.indexOf(purpose) === -1)
            purpose = 'categories'

        return (
            <ViewRecommendations
                isFetching={isFetching}

                isFetchingAccountSettings={this.props.isFetchingAccountSettings}
                isFetchingClanSettings={this.props.isFetchingClanSettings}

                page={purpose}
                currentSlide={currentSlide}

                accountSettings={this.props.accountSettings}
                recommendations={this.props.recommendations}
                leftApplicationCount={this.props.leftApplicationCount}

                updateAccountSettings={this.updateAccountSettings}
                getRecommendations={this.getRecommendations}
                getLeftApplicationCount={this.getLeftApplicationCount}
                sendApplication={this.sendApplication}
                root={this.props.root}

                currentAccount={this.props.currentAccount} />
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContainerRecommendations)